import { createContext } from 'react';

const TracksContext = createContext();

export default TracksContext;
